import { todayDate } from "./dates.js";

// True when a game hasn't come out yet. Prefer the precise release_date; fall
// back to release_year for games added before dates were captured (a future
// year counts as upcoming).
export function isUpcoming(game, todayStr, currentYear) {
	if (game.release_date) return game.release_date > todayStr;
	if (game.release_year) return game.release_year > currentYear;
	return false;
}

// Sort key: precise ISO dates order naturally; year-only entries fall at the
// end of their year, after any dated release in the same year.
export function releaseSortKey(game) {
	return game.release_date ?? `${game.release_year}-12-31`;
}

// Unreleased items (games or books — anything with release_year/release_date),
// soonest first.
export function upcoming(items) {
	const today = todayDate();
	const currentYear = new Date().getFullYear();
	return items
		.filter((item) => isUpcoming(item, today, currentYear))
		.sort((a, b) => releaseSortKey(a).localeCompare(releaseSortKey(b)));
}
